// extracted by mini-css-extract-plugin
module.exports = {"sub_header":"StrategyTickersTable_sub_header__2dR5_","sub_header__add_btn":"StrategyTickersTable_sub_header__add_btn__2olr7"};